import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { SystemUser2 } from '../models/system-user2';
import { SystemUser } from '../models/User';
import { User } from '../shared/User';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  systemUsers: SystemUser2[] = [];
  _tempUsersArray: SystemUser2[] = [];
  isSearchOn: boolean = false;


  constructor(private http: HttpClient) { 

    this.getUsers();

  }

  search(searchInput:string){
   
      this.systemUsers = this._tempUsersArray;
      this.systemUsers = this.systemUsers.filter(x=> x.username.toLowerCase().includes(searchInput.toLowerCase()));
  }

  userSearchInit(){
    this.systemUsers = this._tempUsersArray;
  }

  editUserDetails(newUserDetails:any): Observable<any>{

    return this.http.put<any>('core-service/api/systemuser', newUserDetails)
    .pipe(catchError(this.handleError<any>('edit user details', 'error')));
  }

  //soft deleting
  deleteUser(userToDelete:any): Observable<any>{

    return this.http.request('delete', 'core-service/api/systemuser', { body: userToDelete })
    .pipe(catchError(this.handleError<any>('edit user details', 'error')));
  }

  createUser(newUserDetails:any): Observable<any>{

    return this.http.post<any>('core-service/api/systemuser', newUserDetails)
    .pipe(catchError(this.handleError<any>('create user', 'error')));
  }

  softUpdateUser(updated: any) {
    for (let i in this.systemUsers) {
      let temp = this.systemUsers[i];
      if (temp.username == updated.username) {
        this.systemUsers[i] = updated;
      }
    }
  }

  softAddUser(added: any) {
    var userFound = false
    for (let i in this.systemUsers) {
      let temp = this.systemUsers[i];
      if (temp.username == added.username) {
        userFound = true;
        break;
      }
    }
    if (!userFound) {
      this.systemUsers.push(added);
    }
  }

  //replace old get users with this eventually
  xgetUsers() : Observable <SystemUser[]> {
    return this.http.get<SystemUser[]>("core-service/api/systemuser");
  }

  getUsers(): void {

    this.systemUsers = [];

    let temp = this.http.get<any>('core-service/api/systemuser').pipe(
      tap((some: any) => console.log('users: ', some)),
      catchError(this.handleError<any>('getUsers'))
    ).subscribe(res =>{
      this.systemUsers = res
      this._tempUsersArray = res; //store
    });
  }



  //no longer used
  addUsersToGroup(groupId: number, usersArr: string[]): Observable<any> {


    var httpOptions = {

      group_id: groupId,
      users: usersArr,
      headers: {
        'Content-Type': "application/json;charset=utf-8"
      }
    }

    return this.http.put('rsmservice/users', httpOptions);
  }

  //this is not longer used
  removeUsersFromGroup(groupId: number, usersArr: string[]) : Observable<any>{

  

    var httpOptions = {

      body: {
        group_id: groupId,
        users: usersArr
      },

      headers: {
        'Content-Type': "application/json;charset=utf-8"
      }
    }


    console.log(httpOptions);

    return this.http.delete('/rsmservice/users', httpOptions);
  }



  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}